import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from './buttons/basicButtons/PrimaryButton.sc';
import SecondaryButton from './buttons/basicButtons/SecondaryButton.sc';
import { ButtonSection } from '~src/modules/okrs/manageObjectives/create/addObjectiveEntityForm.sc';
import Dialog from './dialogs/dialog/Dialog';

interface ConfirmationModalInterface {
  show: boolean;
  modalBody: string;
  onCancel: () => void;
  onSubmit: () => void;
  submitButtonText: string;
}

export const ConfirmationModal: FC<ConfirmationModalInterface> = ({
  show = false,
  onCancel,
  onSubmit,
  submitButtonText,
  modalBody,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      show={show}
      onHide={onCancel}
      children={
        <section>
          <div>{modalBody}</div>
          <ButtonSection>
            <SecondaryButton type="button" onClick={onCancel} data-translation="x.button.cancel">
              {t('x.button.cancel')}
            </SecondaryButton>
            &nbsp;
            <PrimaryButton type="button" onClick={onSubmit} data-translation="x.invite.from">
              {submitButtonText}
            </PrimaryButton>
          </ButtonSection>
        </section>
      }
    />
  );
};
